import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import productsBannerImage from 'src/modules/products/assets/products-banner.jpg';
import { Media } from 'vendor/mods/media-breakpoints-fresnel/components/Media';

const ImageContainer = styled.div`
  justify-self: center;
  height: 327px;
  position: relative;
`;

const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: center center;
`;

export const ProductsBannerImageDesktop = () => {
  return (
    <Media greaterThanOrEqual="desktop">
      <ImageContainer>
        <StyledImage src={productsBannerImage} layout="fill" sizes="100vw" />
      </ImageContainer>
    </Media>
  );
};
